/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CatalogItemSortBy {
  PRICE = 'price',
}
